// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcs_a bhy_wl","LoadingPlaceholder":"bcs_b bhy_h","loading-placeholder":"bcs_c"};